import React from 'react';

export const allowedImageTypes = ['image/x-png', 'image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
const fileTypes = ['JPG', 'PNG', 'GIF'];

export const allowedTmageTypesMsg = `File format is not allowed. Please try ${fileTypes.join(', ')}`;

export const maxImageSizeBytes = 5240000; // 5MB
export const imageTooLargeMsg = 'Sorry, your file is too large. It should be less than 5 Mb.';

// file-service endpoints
export const fileServiceApiRoot = '/api/files';

export const galleryImageUploadUrl = `${fileServiceApiRoot}/upload-image`;
export const messageImageUploadUrl = `${fileServiceApiRoot}/message/upload-image`;
export const avatarImageUploadUrl = `${fileServiceApiRoot}/upload-avatar-image`;

export const uploadFailedMsg = 'File upload failed. Please check your connection and try again.';
export const uploadUnauthorizedMsg = 'Your session has expired. Please sign in again and retry the upload.';

// For responses that resolve without throwing (for example - the axiosInstance refresh
// interceptor resolves with the original 401 response after a failed refresh).
export const getUploadResponseErrorMsg = (status) =>
  status === 401 ? uploadUnauthorizedMsg : uploadFailedMsg;

export const getUploadErrorMsg = (error) =>
  getUploadResponseErrorMsg(error?.response?.status);

export const imgTooltipLabel = <span>Accepted Files: {fileTypes.join(', ')}<br />Max Size: 5MB</span>;
